module.exports = __webpack_public_path__ + "img/1452538108.40eab490.jpg";